import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=45c31d6f&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=45c31d6f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c31d6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45c31d6f')) {
      api.createRecord('45c31d6f', component.options)
    } else {
      api.reload('45c31d6f', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=45c31d6f&scoped=true", function () {
      api.rerender('45c31d6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/erpIntegrationLog/Main.vue"
export default component.exports